import React, { useState, useEffect } from 'react';
import './CookieBanner.css';

const CookieBanner = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShow(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="cookie-banner">
      <div className="cookie-content">
        <div className="cookie-text">
          <p>
            🍪 We use essential services like Google Fonts and Web3Forms to improve your experience. 
            By continuing to use this site, you agree to our use of these services.{' '}
            <a href="/privacy" className="cookie-link">Privacy Policy</a>
          </p>
        </div>
        <button onClick={acceptCookies} className="cookie-accept-btn">
          Accept
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
